/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 *   IMPORTANT: This file is used by the internal build
 *   script `extract-intl`, and must use CommonJS module syntax
 *   You CANNOT use import/export in this file.
 */
import '@formatjs/intl-pluralrules/dist/locale-data/en'
import '@formatjs/intl-pluralrules/dist/locale-data/es'
import '@formatjs/intl-pluralrules/dist/locale-data/pt'
import '@formatjs/intl-pluralrules/dist/locale-data/zh'

import enTranslationMessages from '../translations/en.json'
import esTranslationMessages from '../translations/es.json'
import ptTranslationMessages from '../translations/pt.json'
import zhTranslationMessages from '../translations/zh.json'

import { getLang } from './url_parser'

export const DEFAULT_LOCALE = getLang()

// prettier-ignore
export const appLocales = [
  'en',
  'es',
  'pt',
  'zh'
]

export const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages) : {}
  const flattenFormattedMessages = (formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE ? defaultFormattedMessages[key] : messages[key]
    return Object.assign(formattedMessages, { [key]: formattedMessage })
  }
  return Object.keys(messages).reduce(flattenFormattedMessages, {})
}

export const translationMessages = {
  en: formatTranslationMessages('en', enTranslationMessages),
  es: formatTranslationMessages('es', esTranslationMessages),
  pt: formatTranslationMessages('pt', ptTranslationMessages),
  zh: formatTranslationMessages('zh', zhTranslationMessages)
}
